import { getFormattedDate } from '../utils/utils';
import { getStatus, getOrderType } from './utils';

export class OrderListModel {
  constructor(data) {
    const {
      status,
      quoteStatus,
      businessLegalName,
      productSelection,
      productType,
      businessLegalNameNonProfit,
      businessLegalNamePersonal,
      businessLegalNameQuoteTool,
      orderId,
      createdAt,
      updatedAt,
      validatedAt,
      orderCreatedBy,
      channel
    } = data || {};
    const {statusText, tooltip} = getStatus(status, quoteStatus) || '-';
    this.status = ["Submitted", "Soumis"].includes(statusText) ? tooltip: statusText;
    this.createdBy = orderCreatedBy ? `${orderCreatedBy.firstName} ${orderCreatedBy.lastName}` : '';
    this.channel = channel ? channel.name : '-';
    this.businessLegalName =
      businessLegalName ||
      businessLegalNameNonProfit ||
      businessLegalNamePersonal ||
      businessLegalNameQuoteTool;
    this.typeOfInstallation = getOrderType(productSelection, productType);
    this.orderId = orderId;
    this.updatedAt =
      (updatedAt && getFormattedDate(updatedAt, 'YYYY-MM-DD')) || '-';
    this.createdAt =
      (createdAt && getFormattedDate(createdAt, 'YYYY-MM-DD')) || '-';
    this.validatedAt =
      (validatedAt && getFormattedDate(validatedAt, 'YYYY-MM-DD')) || '-';
  }
}

export class OrderHeaderModel {
  constructor(data) {
    const {
      orderId,
      businessLegalName,
      typeOfInstallation,
      businessLegalNameNonProfit,
      businessLegalNamePersonal,
      businessLegalNameQuoteTool,
      createdAt,
      updatedAt,
      validatedAt,
      orderStatus,
      channel,
      createdBy,
      actions
    } = data || {};
    this.orderId = orderId;
    this.businessLegalName =
      businessLegalName ||
      businessLegalNameNonProfit ||
      businessLegalNamePersonal ||
      businessLegalNameQuoteTool;
    this.typeOfInstallation = typeOfInstallation;
    this.updatedAt = updatedAt;
    this.createdAt = createdAt;
    this.validatedAt = validatedAt;
    this.status = orderStatus;
    this.channel = channel,
    this.createdBy = createdBy
    this.actions = actions;
  }
}
